export default "__VITE_ASSET__B_Tpiw95__"